import { create, type StateCreator } from 'zustand';

import { getAvailableAppointmentTypes } from '@/lib/helpers/appointmentTypes';
import { logger } from '@/store/logger';
import {
  DearDocAppointmentTypes,
  DearDocConnection,
  DearDocFreeSlots,
  DearDocProvider,
} from '@/types/api.types';

interface PracticeState {
  connection: DearDocConnection | null;
  providers: DearDocProvider[];
  freeSlots: DearDocFreeSlots | null;
  availableAppointmentTypes: DearDocAppointmentTypes[];
}

export type PracticeStore = PracticeState & {
  setConnection: (connection: DearDocConnection | null) => void;
  setProviders: (providers: DearDocProvider[]) => void;
  setFreeSlots: (freeSlots: DearDocFreeSlots | null) => void;
};

export const initialState: Pick<PracticeStore, keyof PracticeState> = {
  connection: null,
  providers: [],
  freeSlots: null,
  availableAppointmentTypes: [],
};

const createProvidersSlice: StateCreator<PracticeStore> = (set) => ({
  ...initialState,
  setConnection: (connection: DearDocConnection | null) => {
    set({ connection });
  },
  setProviders: (providers: DearDocProvider[]) => {
    const availableAppointmentTypes = getAvailableAppointmentTypes(providers);
    set({ providers, availableAppointmentTypes });
  },
  setFreeSlots: (freeSlots: DearDocFreeSlots | null) => {
    set({ freeSlots });
  },
});

export const usePracticeStore = create<PracticeStore>()(
  logger<PracticeStore>(createProvidersSlice, 'ProvidersStore'),
);
